import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

/* ===============================
   GET VENDOR BILLS
================================ */
export const getVendorBills = createAsyncThunk(
  "bill/getVendorBills",
  async ({ vendorId, page = 1, limit = 10, search }, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/invoice/vendor/${vendorId}?page=${page}&limit=${limit}&search=${search || ""}`
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch bills"
      );
    }
  }
);

/* ===============================
   GET SINGLE BILL
================================ */
export const getSingleBill = createAsyncThunk(
  "bill/getSingleBill",
  async (billId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/invoice/single/${billId}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch bill"
      );
    }
  }
);

/* ===============================
   UPDATE BILL
================================ */
export const updateBill = createAsyncThunk(
  "bill/updateBill",
  async ({ billId, billData }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/invoice/update/${billId}`, billData);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update bill"
      );
    }
  }
);

/* ===============================
   BILL SLICE
================================ */
const billSlice = createSlice({
  name: "bill",
  initialState: {
    loading: false,
    bills: [],
    bill: null,
    pagination: null,
    success: false,
    error: null,
  },

  reducers: {
    clearBillState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    clearSingleBill: (state) => {
      state.bill = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== GET VENDOR BILLS ===== */
      .addCase(getVendorBills.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendorBills.fulfilled, (state, action) => {
        state.loading = false;
        state.bills = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getVendorBills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== GET SINGLE BILL ===== */
      .addCase(getSingleBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleBill.fulfilled, (state, action) => {
        state.loading = false;
        state.bill = action.payload.data;
      })
      .addCase(getSingleBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE BILL ===== */
      .addCase(updateBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBill.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.bill = action.payload.data;
      })
      .addCase(updateBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBillState, clearSingleBill } = billSlice.actions;
export default billSlice.reducer;
